import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgChevronDown } from "@digits-shared/components/SVGIcons/line/ChevronDown.svg"
import styled, { css } from "styled-components"

export const DEFAULT_ELEMENTS_PER_SCROLLABLE_PAGE = 7
export const ELEMENTS_PER_BROWSING_SCROLL = 3

export const HorizontalScrollPointingChevron = styled(SvgChevronDown)`
  ${svgPathStyles("var(--scroll-chevron-disabled-color)", 1.5)};
  width: 25px;
  height: 25px;
  cursor: pointer;
  transition: transform 200ms ease;
`

export interface HorizontalScrollChevronProps {
  $isDisabled?: boolean
  $hideOnDisabled?: boolean
}

const HORIZONTAL_SCROLL_CHEVRON_STYLES = css<HorizontalScrollChevronProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 3px;
  height: 100%;
  width: 30px;
  font-size: 45px;
  z-index: 0;
  cursor: pointer;
  transition: opacity 250ms ease;

  ${({ $isDisabled, $hideOnDisabled }) =>
    $isDisabled
      ? css`
          transition: none;
          cursor: auto;
          pointer-events: none;
          opacity: ${$hideOnDisabled ? 0 : 0.5};
        `
      : css`
          opacity: 1;

          &:hover ${HorizontalScrollPointingChevron} {
            ${svgPathStyles("var(--scroll-chevron-active-color)", 1.5)};
          }
        `};
`

export const LeftScrollChevron = styled.div<HorizontalScrollChevronProps>`
  ${HORIZONTAL_SCROLL_CHEVRON_STYLES};

  ${HorizontalScrollPointingChevron} {
    transform: rotate(90deg);
  }

  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover ${HorizontalScrollPointingChevron} {
        transform: rotate(90deg) translateY(2px);
      }
    `}
`

export const RightScrollChevron = styled.div<HorizontalScrollChevronProps>`
  ${HORIZONTAL_SCROLL_CHEVRON_STYLES};

  ${HorizontalScrollPointingChevron} {
    transform: rotate(-90deg);
  }

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          opacity: 0.1;
        `
      : css`
          &:hover ${HorizontalScrollPointingChevron} {
            transform: rotate(-90deg) translateY(2px);
          }
        `}
`
